






































































































































































































import { PropType, defineComponent, computed, ComputedRef, onMounted, ref, getCurrentInstance } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import { useCommonHooks, calcRemainingDays, formatRemindTime } from './help';
import {
  IntentRiskType,
  StatisticType,
  GroupData,
  RiskSituation,
  RiskDataType,
  RiskStatisticType,
  RiskType,
  LevelType
} from './type';
import { useRender } from '../../../hooks/useRender';
import { isOverseasVersion } from 'common-module/src/util';

export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const instance = getCurrentInstance();
    const showDailyField: Array<('overDueWorkRisk' | 'memberRisk' | 'progressRisk' | 'taskRisk')
      & (keyof RiskSituation)> = ['overDueWorkRisk', 'memberRisk', 'progressRisk', 'taskRisk'];
    const intentCode = props.message.content.report.base.intentCode as IntentRiskType;
    const reportData = computed(() => {
      return props.message.content.report.reportData as RiskDataType;
    });
    const riskSituation = reportData.value.riskSituation as RiskSituation;
    const reportType = props.message.content.report.reportType;
    const workStatisticType = computed(() => reportData.value.workStatisticType) as ComputedRef<StatisticType>;
    const remainDay = ref({
      isToday: false,
      days: 0,
      isOverdue: false
    });
    const riskUnit = {
      overDueWorkRisk: (num: number) => tc('common.count.issueCountAre', num, { num }),
      memberRisk:(num: number) => tc('common.count.memberAre', num, { num }),
      progressRisk: () => '',
      taskRisk: (num: number) => tc('common.count.issueCountAre', num, { num })
    };
    const levelUnit = {
      3: t('saas.robotChat.High'),
      2: t('saas.robotChat.Medium'),
      1: t('saas.robotChat.Low'),
      0: t('saas.robotChat.None')
    };
    const iconMap = {
      taskRisk: 'zkicon iconrenwuliebiao',
      memberRisk: 'zkicon iconrenyuan',
      overDueWorkRisk: 'zkicon iconshijianriqi',
      progressRisk: 'zkicon iconjindutiao'
    };

    const tipsByRiskMap = {
      memberRisk: {
        0: '',
        1: t('saas.robotChat.memberRiskTipsLow'),
        2: t('saas.robotChat.memberRiskTipsMedium'),
        3: t('saas.robotChat.memberRiskTipsHigh')
      },
      overDueWorkRisk: {
        0: '',
        1: t('saas.robotChat.overDueWorkRiskTipsLow'),
        2: t('saas.robotChat.overDueWorkRiskTipsMedium'),
        3: t('saas.robotChat.overDueWorkRiskTipsHigh')
      },
      taskRisk: {
        0: '',
        1: t('saas.robotChat.taskRiskTipsLow'),
        2: t('saas.robotChat.taskRiskTipsMedium'),
        3: t('saas.robotChat.taskRiskTipsHigh')
      },
      progressRisk: {
        0: '',
        1: t('saas.robotChat.progressRiskTipsLow'),
        2: t('saas.robotChat.progressRiskTipsMedium'),
        3: t('saas.robotChat.progressRiskTipsHigh')
      }
    };

    const {
      intentCodeTranslateMap,
      unitTranslateMap,
      transformUnitByStatisticType,
      transformMemberListNeedData
    } = useCommonHooks();
    const fixedTitleMap = intentCodeTranslateMap[intentCode];

    const listMap = computed(() => {
      return showDailyField.map(key => {
        return {
          key,
          ...(riskSituation[key] as RiskType)
        };
      });
    });
    const riskUserList = computed(() => riskSituation.memberRisk?.users || []);
    const { openAside } = useRender();
    const openAsideComponent = (
      issueIds: Array<number>,
      type: string,
      hasGroup?: Array<GroupData> | null,
      key?: RiskStatisticType | 'riskSituation' | '',
      level?: LevelType | '',
      trackType?: string,
      trackParam?: any
    ) => {
      let showHeaderTips = '';
      if (key === 'riskSituation') {
        showHeaderTips = t('saas.robotChat.riskTipsCommon');
      } else if (key && level) {
        showHeaderTips = tipsByRiskMap[key][level];
      }
      openAside(() => import('../../aside-component/IssueList.vue'), {
        ...props.message,
        title: `${t('backlog.Sprint')}: ${reportData.value.sprintName} ${type}`,
        showHeaderTips,
        content: {
          issueIds: issueIds,
          showStayDays: true,
          loadListById: true,
          hasGroup
        }
      });

      if (trackType) {
        instance?.proxy.$track.send(trackType, trackParam, true);
      }
    };

    const summaryList = computed(() => {
      const o = {
        total: reportData.value.statistics.total,
        inProgress: reportData.value.statistics.inProgress,
        done: reportData.value.statistics.done
      };
      return o;
    });

    onMounted(async() => {
      remainDay.value = await calcRemainingDays(reportData.value);
    });
    return {
      t,
      tc,
      reportType,
      reportData,
      remainDay,
      formatRemindTime,
      intentCode,
      unitTranslateMap,
      transformUnitByStatisticType,
      fixedTitleMap,
      listMap: listMap.value.sort((a, b) => {
        return b.level - a.level;
      }),
      openAsideComponent,
      workStatisticType,
      summaryList,

      riskSituation,
      riskUserList,
      riskUnit,
      levelUnit,
      overseas: isOverseasVersion,
      iconMap,
      transformMemberListNeedData
    };
  }
});
